var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRanking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1147 16.3333H4.66634C3.38301 16.3333 2.33301 17.3833 2.33301 18.6666V25.6666H10.1147V16.3333Z",
    stroke: "white",
    strokeWidth: 1.17,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5519 11.6667H12.4368C11.1535 11.6667 10.1035 12.7167 10.1035 14.0001V25.6667H17.8852V14.0001C17.8852 12.7167 16.8469 11.6667 15.5519 11.6667Z",
    stroke: "white",
    strokeWidth: 1.17,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3331 19.8333H17.8848V25.6666H25.6664V22.1666C25.6664 20.8833 24.6164 19.8333 23.3331 19.8333Z",
    stroke: "white",
    strokeWidth: 1.17,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6069 2.41504L15.2253 3.6517C15.3069 3.8267 15.5286 3.99003 15.7153 4.01337L16.8353 4.20004C17.5469 4.3167 17.7219 4.84168 17.2086 5.34335L16.3336 6.21835C16.1819 6.37001 16.1003 6.65002 16.1469 6.84836L16.3919 7.92171C16.5903 8.77337 16.1353 9.10005 15.3886 8.65671L14.3386 8.03838C14.1519 7.92171 13.8369 7.92171 13.6503 8.03838L12.6003 8.65671C11.8536 9.10005 11.3986 8.77337 11.5969 7.92171L11.8419 6.84836C11.8886 6.65002 11.8069 6.35835 11.6553 6.21835L10.7919 5.35503C10.2786 4.84169 10.4419 4.32835 11.1653 4.21168L12.2853 4.02504C12.4719 3.99004 12.6936 3.82671 12.7753 3.66338L13.3936 2.42668C13.7319 1.75001 14.2686 1.75004 14.6069 2.41504Z",
    stroke: "white",
    strokeWidth: 1.17,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRanking);
export default __webpack_public_path__ + "static/media/ranking.e65cdbcb76b88cc91eb03ebc40b3ea5d.svg";
export { ForwardRef as ReactComponent };